// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37561d8a","455":"a379f54d","977":"c2249bec"}[chunkId] + ".chunk.js";
};